<div>
    <div class="no-products">
        <div class="no-result-icon">
            <img src="/assets/images/no-result.png" />
        </div>
        <h2>{{ message ? message : 'Sorry, no results found!' }}</h2>
    </div>
</div>